import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class TrueOrFalseProps {
  @Inlet(Accepts.Image) public image?: Types["Image"];

  @Inlet(Accepts.ImageFilter) public imageFilter?: Types["ImageFilter"];
  @Inlet(Accepts.Image) public cardImage?: Types["Image"];

  @Inlet(Accepts.Text) public title?: Types["Text"];
  @Inlet(Accepts.MarkdownText) public question?: Types["MarkdownText"];
  @Inlet(Accepts.TrueOrFalse) public answer?: Types["TrueOrFalse"];

  @Inlet(Accepts.TrueOrFalseLayout)
  public optionLayout?: Types["TrueOrFalseLayout"];
  @Inlet(Accepts.IdAndLabelList) public cards?: Types["IdAndLabelList"];

  @Inlet(Accepts.Void) public logic?: Types["Void"];
}

export const TrueOrFalseDefinition = defineElement(
  "true-or-false",
  TrueOrFalseProps,
  {
    versionRequired: "0.38.0",
  }
);

export const TRUE_OR_FALSE_ACTIONS = {
  onTrueSelected: "on-true-selected",
  onFalseSelected: "on-false-selected",
};
